var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-icon",style:(_vm.cssVars),attrs:{"id":"line"}},[_c('svg',{staticClass:"dotIcon",attrs:{"width":"4","height":"4"}},[_c('circle',{attrs:{"fill":_vm.colors.primary,"cx":"2","cy":"2","r":"2","id":"dot"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }